import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useNewPatients } from 'app/components/analytics-new-patients/useNewPatients'
import { NewPatientsShadcnComponent } from 'app/components/analytics-new-patients/NewPatientsShadcnComponent'
import { defaultBecameLeadDateFilter } from 'app/components/analytics-new-patients/useNewPatients'
import { useCheckPermission } from 'app/hooks/useCheckPermission'

// Re-export for backwards compatibility
export { defaultBecameLeadDateFilter }

// observer: reads authStore.user/permissions in render, which resolve asynchronously (TRK-6020).
const NewPatients = observer(function NewPatients() {
  const checkPermission = useCheckPermission()

  // Permission guard (PMS integration check now handled by the hook/component)
  if (!checkPermission([`org:pages:analytics:new-patients`, `pages:analytics`])) {
    return <Navigate to="/analytics/marketing" replace />
  }

  const hookData = useNewPatients()
  return <NewPatientsShadcnComponent {...hookData} />
})

export default NewPatients
